<template>
  <div class="w-full flex items-center gap-3 pt-4 justify-start">
    <vs-button
      class="bg-gtr border-0 text-white lg:py-3 font-normal text-sm md:py-3 py-1 px-6"
      @click="handleTestPayment"
    >
      {{ this.buttonName || "Test" }}
    </vs-button>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      // testAmount: 1,
      currTransactionId: "",
      orderCreationId: null,
    };
  },
  props: {
    amount: {
      type: Number,
      required: true,
    },
    buttonName: {
      type: String,
    },
    currency: {
      type: String,
    },
    gateway: {
      type: Object,
      required: true,
    },
  },

  methods: {
    async handleTestPayment() {
      let self = this;
      var amount = Number(this.amount) * 100;
      var paymentRecord = async (response) => {
        var responcenew = await this.handlePaymentRecord(response);

        // this.currTransactionId = responcenew.data._id;
        if (responcenew) {
          // const payload = {
          //   adminId: this.login._id,
          //   price: Number(Number(amount).toFixed(2)),
          //   transactionId: responcenew.data._id,
          //   transactionStatus: "In-Process",
          // };
          // let loader = this.$loading.show();
          // let loader = this.$loading.show({});
          let loader = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          try {
            // const data = await this.$store.dispatch(
            //   "payment/CreatePayment",
            //   payload
            // );
            // console.log("PAYMENTCREATE:", data);
            // if (data.code == 200) {
            // this.success();
            // this.renderOperation();
            // this.$vs.loading.close();
            let TransPayload = {
              _id: this.currTransactionId,
              price: Number(Number(this.amount).toFixed(2)),
              // transactionId: responcenew.data.transactionId,
              transactionStatus: "In-Process",
            };
            await this.$store.dispatch(
              "Transaction/updateTransaction",
              TransPayload
            );
            // console.log(responcenew);
            let verifyPayload = {
              razorpay_order_id: responcenew.razorpayKey.razorpay_order_id,
              razorpay_payment_id: responcenew.razorpayKey.razorpay_payment_id,
              razorpay_signature: responcenew.razorpayKey.razorpay_signature,
              transactionId: this.currTransactionId,
              gatewayId: this.gateway._id,
              test: true,
            };

            let verifyData = await this.$store.dispatch(
              "Payment/razorpayVerifySignature",
              verifyPayload
            );
            loader.close();
            if (verifyData && verifyData.code === 200) {
              // if (status && status.code === 200 && status.data) {
              if (verifyData.data.signatureIsValid === true) {
                await self.updateGateway("Success");
                await self.handleSuccessTransaction();
              } else {
                await self.updateGateway("Failed");
                await self.handleFaliedTransaction();
              }
              // }
              await self.getGateway();
              console.log("Success");
            } else {
              await self.updateGateway("Failed");
              await self.handleFaliedTransaction();
              console.log("Verification failed");
            }
            // let getUserPayload = {
            //   userId: this.user._id,
            // };
            // const getUser = await this.$store.dispatch(
            //   "auth/getUserByUserId",
            //   getUserPayload
            // );
            // console.log("GETUSERBYUSERID:", this.getUserByUserId);
            // loader.hide();
            // console.log("In-Process");
            // this.$router.push({ name: "myorder" });
            // }
            // loader.hide();
          } catch (error) {
            // this.$vs.loading.close();
            // this.error(error);
            loader.close();
            self.handleFaliedTransaction();
            console.log(error);
          }
        }
      };

      await this.createTransaction();
      this.$store
        .dispatch("Payment/razorpayCreateOrder", {
          gatewayId: this.gateway._id,
          amount: Number(amount),
          currency: "INR",
          receipt: "testReceipt",
        })
        .then(async (_) => {
          // console.log(_);
          if (Object.keys(_.data).length == 0) {
            // return this.$notify.error({
            //   message: "Payment failed",
            //   position: "bottom-right",
            // });
            self.handleFaliedTransaction();
            console.log("Payment failed");
            return;
          }
          // console.log(this.razorpay);
          // this.orderCreationId = _.data.id;
          var options = {
            key: this.razorpay.clientId,
            amount: _.data.amount.toString(),
            currency: this.currency,
            order_id: _.data.id,
            handler: function (response) {
              paymentRecord(response);
            },
            // prefill: {
            //   name: `${this.user.firstname} ${this.user.lastname}`,
            //   email: `${this.user.email}`,
            //   phone: `${this.user.mobile}`,
            // },
          };
          var rzp1 = new Razorpay(options);
          rzp1.on("payment.failed", async function (response) {
            console.log("FAILEDTRANSACTION", response.error);
            self.handleFaliedTransaction();
            await self.updateGateway("Failed");
            await self.getGateway();
          });
          rzp1.open();
        })
        .catch((error) => {
          // this.checkoutMessage = "Out of Stock",
          //  this.$notify.error({
          //     message: "Out of Stock",
          //     position: "bottom-right",
          //   })
          self.handleFaliedTransaction();
          console.log(error);
        });
    },
    async handlePaymentRecord(responce) {
      try {
        // console.log(responce);
        let payload = {
          transactionId: this.currTransactionId,
          transactionStatus: "In-Process",
          transactionMode: "Online",
          // transactionType: "Razorpay",
          // orderId: responce.razorpay_order_id,
          adminId: this.login._id,
          razorpayKey: {
            // orderCreationId: this.orderCreationId,
            razorpay_payment_id: responce.razorpay_payment_id,
            razorpay_order_id: responce.razorpay_order_id,
            razorpay_signature: responce.razorpay_signature,
          },
        };
        const transactionrecord = await this.$store.dispatch(
          "Transaction/updateTransaction",
          payload
        );
        // console.log("TRANSACTIONCREATE:", transactionrecord);
        // this.currTransactionId = transactionrecord._id;
        return transactionrecord.data;
      } catch (err) {
        // this.error(err);
        this.handleFaliedTransaction();
        console.log(err);
      }
    },
    async handleFaliedTransaction() {
      try {
        let TransPayload = {
          transactionId: this.currTransactionId,
          transactionStatus: "Failed",
        };
        console.log(TransPayload);
        let data = await this.$store.dispatch(
          "Transaction/updateTransaction",
          TransPayload
        );
      } catch (err) {
        // this.error(err);
        console.log(err);
      }
    },
    async handleSuccessTransaction() {
      try {
        let TransPayload = {
          transactionId: this.currTransactionId,
          transactionStatus: "Success",
        };
        let data = await this.$store.dispatch(
          "Transaction/updateTransaction",
          TransPayload
        );
      } catch (err) {
        // this.error(err);
        console.log(err);
      }
    },
    async createTransaction() {
      try {
        let payload = {
          transactionStatus: "In-Process",
          transactionMode: "Online",
          transactionType: "razorpay",
          adminId: this.login._id,
          gatewayId: this.gateway._id,
        };
        const transactionrecord = await this.$store.dispatch(
          "Transaction/createTransaction",
          payload
        );
        this.currTransactionId = transactionrecord.data._id;
        // console.log("TRANSACTIONCREATE:", transactionrecord);
        let gatewayPayload = {
          gatewayId: this.gateway._id,
          transactionId: this.currTransactionId,
          adminId: this.login._id,
        };
        const gatewayRecord = await this.$store.dispatch(
          "Payment/editGateway",
          gatewayPayload
        );
        return transactionrecord;
      } catch (err) {
        // this.error(err);
        console.log(err);
      }
    },
    async updateGateway(verifyStatus) {
      try {
        let payload = {
          gatewayId: this.gateway._id,
          verified: verifyStatus,
          adminId: this.login._id,
          // transactionId: this.currTransactionId,
        };
        const gatewayRecord = await this.$store.dispatch(
          "Payment/editGateway",
          payload
        );
        if (gatewayRecord.code === 200) {
          let emailPayload = {
            to: "maneesh.mashelkar@aiab.in",
            data: {
              isVerified: verifyStatus,
              displayName: this.selectedProject.displayName,
              projectName: this.selectedProject.projectName,
              provider: "Razorpay",
            },
          };
          const EmailRecord = await this.$store.dispatch(
            "Payment/sendEmail",
            emailPayload
          );
        }
      } catch (err) {
        // this.error(err);
        console.log(err);
      }
    },
    async getGateway() {
      try {
        let data = await this.$store.dispatch("Payment/getGateway");
      } catch (err) {
        // this.error(err);
        console.log(err);
      }
    },
  },
  async mounted() {
    try {
      let payload = {
        gatewayId: this.gateway._id,
        provider: "razorpay",
        isDeleted: false,
      };
      const gatewayRecord = await this.$store.dispatch(
        "Payment/getSingleGateway",
        payload
      );
    } catch (err) {
      // this.error(err);
      console.log(err);
    }
    // console.log(gatewayRecord);
    // console.log(this.razorpay);
  },
  computed: {
    ...mapState("brandProfile", ["brandProfile"]),
    ...mapState("Payment", { razorpay: "singlePaymentGateway" }),
    ...mapState("admin", ["login"]),
    ...mapState("user", {
      selectedProject: "selectedProject",
    }),
  },
};
</script>
